<template>
  <b-modal
    centered
    scrollable
    v-if="modal"
    :modal-ok="$t('Confirm')"
    cancel-variant="outline-secondary"
    ok-variant="secondary"
    @ok="userAction"
    @hidden="showModal(false)"
    :visible="modal.showModal"
    :id="modal.modal"
    v-bind="modal.props"
    no-close-on-backdrop
  >
    <template #modal-header>
      <div class="header">
        <div class="title">
          <h4 class="mb-0">{{ modal.title }}</h4>
          <span v-if="modal.subtitle">{{ modal.subtitle }}</span>
        </div>
        <div class="actions">
          <button
            :data-test-id="`${modal.dataTestId}-close`"
            @click="showModal(false)"
          >
            &times;
          </button>
        </div>
      </div>
    </template>
    <component :is="modal.modal" />
    <template :data-test-id="modal.dataTestId" #modal-footer="{ ok, cancel }">
      <b-button
        :size="modal.props.size"
        :variant="cancelVariant"
        :data-test-id="`${
          modal.dataTestId
        }-${cancelTitle.toLowerCase()}-button`"
        @click="cancel()"
        >{{ cancelTitle }}</b-button
      >
      <b-button
        :size="modal.props.size"
        :variant="modal.props.okVariant"
        :data-test-id="`${modal.dataTestId}-${modal.props.okTitle
          .toLowerCase()
          .replace(/\s/g, '-')}-button`"
        @click="ok()"
        >{{ modal.props.okTitle }}</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import modals from "@/modals";

export default {
  name: "TModal",
  components: modals,
  methods: {
    ...mapActions("modal", ["handleUserAction"]),
    ...mapMutations("modal", ["showModal"]),
    /* istanbul ignore next */
    // User action is called onClick of button outside of component scope
    async userAction(bvModalEvent) {
      bvModalEvent.preventDefault();
      await this.handleUserAction();
    },
  },
  computed: {
    ...mapGetters("modal", ["modal"]),
  },
  data() {
    return {
      cancelVariant: "outline-secondary",
      cancelTitle: this.$t("Cancel"),
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal {
  header {
    padding: 1rem 2rem;
    .header {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .actions {
        display: flex;
        align-items: center;
        button {
          background: none;
          border: none;
          padding: 0;
          font-size: 2rem;
        }
      }
    }
  }

  .modal-body {
    padding: 1.5rem 2rem;
  }

  footer {
    border: none;
    background-color: #f7f7f7;

    & > button.btn-outline-secondary {
      border-color: transparent;
      &:hover {
        background: none;
        color: $secondary;
      }
    }
  }
}
</style>
